var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobHadronPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 280 280",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m279.5 280.27h-279l2-39 3.99-20.85 133.51-19.15 133.51 19.15 3.99 20.85z",
    fill: "#4f4f4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m251.79 258.97h-223.58l-26.65-73.33 40.47-57.23 30.41 24.25h135.12l30.41-24.25 40.47 57.23z",
    fill: "#4f4f4f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m221.43 59.86-41.68-43.42h-77.88l-41.69 43.42-2.89 79.58 13.09 68.17h36.74 67.37 36.74l13.09-68.17z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m258.07 313.52h-235.28l-17.68-97.29 135.32-14.11 135.32 14.11z",
    fill: "#2d2d2d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m154.85 50.91h-28.84l-50.83 31.42-4.1 60.02 7.53 63.87 39.6 23.88h44.44l39.44-23.88 7.69-81.55-4.1-42.34z",
    fill: "#333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m64.71 182.31 46.37-12.49 21.74 18.46-13.57 17.7-6.32 29.78-12.14-11.48-23.48-26.72z",
    fill: "#6d6d6d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m217.31 144.26-28.6 26.24-20.77-11.97-27.13-5.84-26.98 5.84-21.28 11.97-29-26.24 4.39-39.35 72.49-45.43 72.49 45.43z",
    fill: "#12b0e0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m184.31 118.39-43.55-9.98-43.31 9.98-35.66-18.97 78.64-74.92 78.64 74.92z",
    fill: "#6d6d6d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m214.89 182.31-41.12-11.49-26.11 17.46 13.57 17.7 6.32 29.78 12.14-11.48 23.52-26.72z",
    fill: "#6d6d6d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m223.95 54.91-43.5-45.26h-80.04l-43.5 45.26-3 81.8 13.57 70.62h12.62l-14.24-56.83 14.85-48.58 33.8-28.76h51.84l33.8 28.76 14.85 48.58-14.24 56.83h12.62l13.57-70.62z",
    fill: "#2d2d2d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3d3d3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m208.41 255.02-67.91 11.25-68.05-11.25-52.69-60.28 8.16-26.08 44 14.26 27.47 36.95 41.04 12.66 41.04-12.66 27.47-36.95 44-14.26 8.16 26.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.97 73.16h-47.69l-15.2-64.68h78.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobHadronPilot);
export default __webpack_public_path__ + "static/media/mob-hadron-pilot.3bf6d9ca97d34f044a210a809e3ffad2.svg";
export { ForwardRef as ReactComponent };